import script from "./UserTransactions.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserTransactions.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__